(function () {
'use strict';
var i18n = window.TVG_I18N || { view_product: 'View product', coming_soon: 'Coming soon' };

// Asset slug overrides (map slug → tvg-*.webp slug)
var IMG_SLUG = {
  'united-states':         'usa',
  'czechia':               'czech-republic',
  'dr-congo':              'congo-dr',
  'bosnia-and-herzegovina':'bosnia-herzegovina'
};

// Nations with a live Shopify product
var WITH_PRODUCT = new Set([
  'brazil','france','japan','mexico','portugal','morocco',
  'united-states','germany','england','canada','spain',
  'netherlands','algeria','dr-congo'
]);

var COUNTRIES = [
  { name:'Norway',               region:'Europe',         confederation:'UEFA',     x:48.079, y:22.314, slug:'norway' },
  { name:'Sweden',               region:'Europe',         confederation:'UEFA',     x:49.707, y:23.291, slug:'sweden' },
  { name:'Scotland',             region:'Europe',         confederation:'UEFA',     x:44.108, y:26.172, slug:'scotland' },
  { name:'England',              region:'Europe',         confederation:'UEFA',     x:45.020, y:28.955, slug:'england' },
  { name:'Netherlands',          region:'Europe',         confederation:'UEFA',     x:46.647, y:29.736, slug:'netherlands' },
  { name:'Germany',              region:'Europe',         confederation:'UEFA',     x:47.949, y:30.371, slug:'germany' },
  { name:'Belgium',              region:'Europe',         confederation:'UEFA',     x:46.061, y:30.762, slug:'belgium' },
  { name:'France',               region:'Europe',         confederation:'UEFA',     x:45.736, y:33.105, slug:'france' },
  { name:'Czechia',              region:'Europe',         confederation:'UEFA',     x:49.967, y:30.322, slug:'czechia' },
  { name:'Switzerland',          region:'Europe',         confederation:'UEFA',     x:47.428, y:32.764, slug:'switzerland' },
  { name:'Austria',              region:'Europe',         confederation:'UEFA',     x:49.642, y:32.129, slug:'austria' },
  { name:'Croatia',              region:'Europe',         confederation:'UEFA',     x:49.707, y:33.691, slug:'croatia' },
  { name:'Bosnia & Herzegovina', region:'Europe',         confederation:'UEFA',     x:50.618, y:33.984, slug:'bosnia-and-herzegovina' },
  { name:'Spain',                region:'Europe',         confederation:'UEFA',     x:44.629, y:36.426, slug:'spain' },
  { name:'Portugal',             region:'Europe',         confederation:'UEFA',     x:42.806, y:36.523, slug:'portugal' },
  { name:'Türkiye',              region:'Europe',         confederation:'UEFA',     x:54.264, y:36.621, slug:'turkiye' },
  { name:'Canada',               region:'Americas',       confederation:'CONCACAF', x:17.415, y:27.783, slug:'canada' },
  { name:'United States',        region:'Americas',       confederation:'CONCACAF', x:16.602, y:37.646, slug:'united-states' },
  { name:'Mexico',               region:'Americas',       confederation:'CONCACAF', x:15.137, y:46.582, slug:'mexico' },
  { name:'Haiti',                region:'Americas',       confederation:'CONCACAF', x:23.405, y:47.607, slug:'haiti' },
  { name:'Curaçao',         region:'Americas',       confederation:'CONCACAF', x:24.251, y:51.025, slug:'curacao' },
  { name:'Panama',               region:'Americas',       confederation:'CONCACAF', x:19.954, y:52.002, slug:'panama' },
  { name:'Colombia',             region:'Americas',       confederation:'CONMEBOL', x:23.079, y:54.639, slug:'colombia' },
  { name:'Ecuador',              region:'Americas',       confederation:'CONMEBOL', x:21.452, y:58.057, slug:'ecuador' },
  { name:'Brazil',               region:'Americas',       confederation:'CONMEBOL', x:31.348, y:62.207, slug:'brazil' },
  { name:'Paraguay',             region:'Americas',       confederation:'CONMEBOL', x:27.702, y:69.043, slug:'paraguay' },
  { name:'Argentina',            region:'Americas',       confederation:'CONMEBOL', x:25.749, y:73.682, slug:'argentina' },
  { name:'Uruguay',              region:'Americas',       confederation:'CONMEBOL', x:28.418, y:73.975, slug:'uruguay' },
  { name:'Cape Verde',           region:'Africa',         confederation:'CAF',      x:38.444, y:48.779, slug:'cape-verde' },
  { name:'Senegal',              region:'Africa',         confederation:'CAF',      x:40.853, y:49.268, slug:'senegal' },
  { name:'Morocco',              region:'Africa',         confederation:'CAF',      x:43.001, y:40.820, slug:'morocco' },
  { name:'Tunisia',              region:'Africa',         confederation:'CAF',      x:47.754, y:39.063, slug:'tunisia' },
  { name:'Algeria',              region:'Africa',         confederation:'CAF',      x:46.387, y:41.357, slug:'algeria' },
  { name:'Egypt',                region:'Africa',         confederation:'CAF',      x:53.418, y:42.969, slug:'egypt' },
  { name:'Ivory Coast',          region:'Africa',         confederation:'CAF',      x:44.108, y:52.881, slug:'ivory-coast' },
  { name:'Ghana',                region:'Africa',         confederation:'CAF',      x:45.345, y:52.930, slug:'ghana' },
  { name:'DR Congo',             region:'Africa',         confederation:'CAF',      x:51.172, y:56.006, slug:'dr-congo' },
  { name:'South Africa',         region:'Africa',         confederation:'CAF',      x:51.074, y:73.291, slug:'south-africa' },
  { name:'Uzbekistan',           region:'Asia & Oceania', confederation:'AFC',      x:62.467, y:35.645, slug:'uzbekistan' },
  { name:'Japan',                region:'Asia & Oceania', confederation:'AFC',      x:83.887, y:38.135, slug:'japan' },
  { name:'South Korea',          region:'Asia & Oceania', confederation:'AFC',      x:81.185, y:39.746, slug:'south-korea' },
  { name:'Iran',                 region:'Asia & Oceania', confederation:'AFC',      x:55.241, y:41.455, slug:'iran' },
  { name:'Iraq',                 region:'Asia & Oceania', confederation:'AFC',      x:60.905, y:41.650, slug:'iraq' },
  { name:'Jordan',               region:'Asia & Oceania', confederation:'AFC',      x:57.650, y:40.332, slug:'jordan' },
  { name:'Qatar',                region:'Asia & Oceania', confederation:'AFC',      x:59.733, y:44.287, slug:'qatar' },
  { name:'Saudi Arabia',         region:'Asia & Oceania', confederation:'AFC',      x:57.715, y:45.654, slug:'saudi-arabia' },
  { name:'Australia',            region:'Asia & Oceania', confederation:'AFC',      x:85.319, y:70.850, slug:'australia' },
  { name:'New Zealand',          region:'Asia & Oceania', confederation:'OFC',      x:95.280, y:77.881, slug:'new-zealand' }
];

// Enrich with image URLs and product availability
COUNTRIES.forEach(function (c) {
  var imgSlug = IMG_SLUG[c.slug] || c.slug;
  c.image      = (window.TVG_MAP_ASSETS && window.TVG_MAP_ASSETS[imgSlug]) || '';
  c.hasProduct = WITH_PRODUCT.has(c.slug);
  c.prodSlug   = IMG_SLUG[c.slug] || c.slug;
});

/* ---- DOM refs ---- */
var canvas      = document.getElementById('tvgm-canvas');
var searchInput = document.getElementById('tvgm-search');
var filterBtns  = Array.from(document.querySelectorAll('.tvgm-filter'));
var listEl      = document.getElementById('tvgm-list');
var statusEl    = document.getElementById('tvgm-status');
var posterImg   = document.getElementById('tvgm-poster-img');
var posterPh    = document.getElementById('tvgm-poster-ph');
var panelName   = document.getElementById('tvgm-panel-name');
var panelRegion = document.getElementById('tvgm-panel-region');
var panelConfed = document.getElementById('tvgm-panel-confed');
var panelShop   = document.getElementById('tvgm-panel-shop');
var panelEl     = document.getElementById('tvgm-panel');
var backdrop    = document.getElementById('tvgm-backdrop');
var closeBtn    = document.getElementById('tvgm-panel-close');

function isMobile() { return window.innerWidth < 900; }
function openSheet() { if (isMobile() && panelEl) { panelEl.classList.add('is-open'); if (backdrop) backdrop.classList.add('is-open'); } }
function closeSheet() { if (panelEl) panelEl.classList.remove('is-open'); if (backdrop) backdrop.classList.remove('is-open'); }

if (closeBtn) closeBtn.addEventListener('click', closeSheet);
if (backdrop) backdrop.addEventListener('click', closeSheet);

var activeRegion = 'all';
var searchTerm   = '';
var activeSlug   = null;

function norm(s) {
  return String(s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '');
}

function isVisible(c) {
  var regionOk = activeRegion === 'all' || c.region === activeRegion;
  var q        = norm(searchTerm);
  var searchOk = !q || norm(c.name).includes(q) || norm(c.region).includes(q);
  return regionOk && searchOk;
}

/* ---- Panel ---- */
function openPanel(slug) {
  var c = COUNTRIES.find(function (x) { return x.slug === slug; });
  if (!c) return;
  activeSlug = slug;

  // hotspots
  document.querySelectorAll('.tvgm-hotspot').forEach(function (n) { n.classList.remove('tvgm-active'); });
  var hs = document.querySelector('.tvgm-hotspot[data-slug="' + slug + '"]');
  if (hs) hs.classList.add('tvgm-active');

  // list
  document.querySelectorAll('#tvgm-list button').forEach(function (n) { n.classList.remove('tvgm-active'); });
  var lb = document.querySelector('#tvgm-list button[data-slug="' + slug + '"]');
  if (lb) lb.classList.add('tvgm-active');

  // poster image
  if (c.image) {
    posterImg.src = c.image;
    posterImg.alt = c.name + ' 2026 — 48 Banners';
    posterImg.style.display = '';
    posterPh.style.display  = 'none';
  } else {
    posterImg.style.display = 'none';
    posterPh.style.display  = '';
    posterPh.textContent    = c.name;
  }

  // Unfold panel on first click — re-sync height after transition completes
  if (panelEl) {
    var wasOpen = panelEl.classList.contains('is-open');
    panelEl.classList.add('is-open');
    if (!wasOpen) {
      panelEl.addEventListener('transitionend', function handler(e) {
        if (e.propertyName === 'width') {
          panelEl.removeEventListener('transitionend', handler);
          syncPanelHeight();
        }
      });
    } else {
      syncPanelHeight();
    }
  }

  panelName.textContent   = c.name;
  panelRegion.textContent = c.region;
  panelConfed.textContent = c.confederation;

  if (c.hasProduct) {
    panelShop.href         = '/products/' + c.prodSlug + '-2026';
    panelShop.textContent  = i18n.view_product;
    panelShop.style.opacity       = '';
    panelShop.style.pointerEvents = '';
  } else {
    panelShop.removeAttribute('href');
    panelShop.textContent  = i18n.coming_soon;
    panelShop.style.opacity       = '0.45';
    panelShop.style.pointerEvents = 'none';
  }

  openSheet();
}

/* ---- Hotspots ---- */
function renderHotspots() {
  COUNTRIES.forEach(function (c) {
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'tvgm-hotspot';
    btn.dataset.slug   = c.slug;
    btn.dataset.region = c.region;
    btn.style.setProperty('--x', c.x + '%');
    btn.style.setProperty('--y', c.y + '%');
    btn.setAttribute('aria-label', c.name);
    btn.innerHTML = '<span class="tvgm-dot"></span><span class="tvgm-tip">' + c.name + '</span>';
    btn.addEventListener('click', function (e) { e.stopPropagation(); openPanel(c.slug); });
    canvas.appendChild(btn);
  });
}

/* ---- Country list (no-op if list element removed) ---- */
function renderList() {
  if (!listEl) return;
  listEl.innerHTML = '';
  var visible = COUNTRIES.filter(isVisible).sort(function (a, b) { return a.name.localeCompare(b.name); });
  visible.forEach(function (c) {
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.textContent = c.name;
    btn.dataset.slug = c.slug;
    if (c.slug === activeSlug) btn.classList.add('tvgm-active');
    btn.addEventListener('click', function () { openPanel(c.slug); });
    listEl.appendChild(btn);
  });
  if (statusEl) {
    statusEl.textContent = activeRegion === 'all' && !searchTerm
      ? 'All 48 nations'
      : visible.length + ' nation' + (visible.length !== 1 ? 's' : '');
  }
}

/* ---- Filters + search dim ---- */
function applyFilter() {
  document.querySelectorAll('.tvgm-hotspot').forEach(function (n) {
    var c = COUNTRIES.find(function (x) { return x.slug === n.dataset.slug; });
    n.classList.toggle('tvgm-dim', !c || !isVisible(c));
  });
  renderList();
}

filterBtns.forEach(function (btn) {
  btn.addEventListener('click', function () {
    filterBtns.forEach(function (b) { b.classList.remove('tvgm-active'); });
    btn.classList.add('tvgm-active');
    activeRegion = btn.dataset.region;
    applyFilter();
  });
});

/* ---- Search ---- */
if (searchInput) {
  searchInput.addEventListener('input', function () {
    searchTerm = searchInput.value.trim();
    applyFilter();
    if (searchTerm) {
      var match = COUNTRIES.find(function (c) { return isVisible(c); });
      if (match) openPanel(match.slug);
    }
  });
}

/* ---- Sync panel height to map height (desktop) ---- */
function syncPanelHeight() {
  if (isMobile()) return;
  var mapColEl = document.querySelector('.tvgm-map-col');
  var h = mapColEl ? mapColEl.offsetHeight : 0;
  if (!h) return;
  panelEl.style.height = h + 'px';
}

/* ---- Init ---- */
renderHotspots();
renderList();
applyFilter();
requestAnimationFrame(function () { requestAnimationFrame(syncPanelHeight); });
window.addEventListener('load', syncPanelHeight);
window.addEventListener('resize', syncPanelHeight);

/* ---- Desktop zoom (wheel + drag + boutons) ---- */
(function () {
  if (isMobile()) return;
  var wrap = document.getElementById('tvgm-zoom-wrap');
  if (!wrap) return;

  var s = 1, ox = 0, oy = 0;
  var MIN = 1, MAX = 5;
  var dragging = false, dragX = 0, dragY = 0;

  canvas.style.transformOrigin = '0 0';

  function clamp(v, a, b) { return Math.max(a, Math.min(b, v)); }

  function clampPan() {
    var ww = wrap.offsetWidth, wh = wrap.offsetHeight;
    var cw = canvas.offsetWidth, ch = canvas.offsetHeight;
    ox = clamp(ox, Math.min(0, ww - cw * s), 0);
    oy = clamp(oy, Math.min(0, wh - ch * s), 0);
  }

  function apply(anim) {
    canvas.style.transition = anim ? 'transform .18s ease' : 'none';
    canvas.style.transform = 'translate3d(' + ox + 'px,' + oy + 'px,0) scale(' + s + ')';
    canvas.style.setProperty('--map-iscale', 1 / s);
    wrap.style.cursor = s > 1 ? 'grab' : 'default';
  }

  /* Mouse drag */
  wrap.addEventListener('mousedown', function (e) {
    if (s <= 1) return;
    dragging = true; dragX = e.clientX; dragY = e.clientY;
    wrap.style.cursor = 'grabbing';
    e.preventDefault();
  });
  document.addEventListener('mousemove', function (e) {
    if (!dragging) return;
    ox += e.clientX - dragX; oy += e.clientY - dragY;
    dragX = e.clientX; dragY = e.clientY;
    clampPan(); apply(false);
  });
  document.addEventListener('mouseup', function () {
    if (!dragging) return;
    dragging = false;
    wrap.style.cursor = s > 1 ? 'grab' : 'default';
  });

  /* +/- buttons */
  function zoomStep(factor) {
    var newS = clamp(s * factor, MIN, MAX);
    var cx = wrap.offsetWidth / 2, cy = wrap.offsetHeight / 2;
    if (newS <= MIN) { s = MIN; ox = 0; oy = 0; }
    else { ox = cx - (cx - ox) * newS / s; oy = cy - (cy - oy) * newS / s; s = newS; }
    clampPan(); apply(true);
  }
  var btnIn  = document.getElementById('tvgm-zoom-in');
  var btnOut = document.getElementById('tvgm-zoom-out');
  if (btnIn)  btnIn.addEventListener('click',  function () { zoomStep(1.5); });
  if (btnOut) btnOut.addEventListener('click', function () { zoomStep(1 / 1.5); });
})();

/* ---- Pinch-to-zoom (mobile only) ---- */
(function () {
  if (!isMobile()) return;
  var wrap = document.getElementById('tvgm-zoom-wrap');
  if (!wrap) return;

  // Start canvas at 2.2× screen width so map is immediately readable
  var MIN_W = window.innerWidth * 0.88; // matches map-col padding
  var curW  = Math.round(MIN_W * 2.2);
  var MAX_W = Math.round(MIN_W * 5);

  canvas.style.width = curW + 'px';
  // Centre the scroll horizontally on load
  wrap.scrollLeft = (curW - wrap.offsetWidth) / 2;

  var lastDist = 0;

  function pinchDist(t1, t2) {
    var dx = t1.clientX - t2.clientX, dy = t1.clientY - t2.clientY;
    return Math.sqrt(dx * dx + dy * dy);
  }

  wrap.addEventListener('touchstart', function (e) {
    if (e.touches.length === 2) {
      lastDist = pinchDist(e.touches[0], e.touches[1]);
    }
  }, { passive: true });

  wrap.addEventListener('touchmove', function (e) {
    if (e.touches.length !== 2) { lastDist = 0; return; }
    e.preventDefault();
    var d = pinchDist(e.touches[0], e.touches[1]);
    if (lastDist > 0) {
      var ratio  = d / lastDist;
      var oldW   = curW;
      curW = Math.max(MIN_W, Math.min(MAX_W, curW * ratio));
      canvas.style.width = curW + 'px';
      // Keep the pinch midpoint stable in the scroll viewport
      var rect  = wrap.getBoundingClientRect();
      var midX  = (e.touches[0].clientX + e.touches[1].clientX) / 2 - rect.left;
      wrap.scrollLeft = (wrap.scrollLeft + midX) * (curW / oldW) - midX;
    }
    lastDist = d;
  }, { passive: false });

  wrap.addEventListener('touchend',   function () { lastDist = 0; }, { passive: true });
  wrap.addEventListener('touchcancel',function () { lastDist = 0; }, { passive: true });
})();

})();
